export type TvWidgetLike = {
  setLayout?: (layout: string) => void;
  chart?: (index: number) => {
    setSymbol?: (symbol: string, opts?: any) => void;
    setResolution?: (interval: string, opts?: any) => void;
    applyOverrides?: (overrides: Record<string, any>) => void;
  } | null;
  unloadUnusedCharts?: () => void;
};

export function applyDefaultOptionsTwoPaneLayout(
  tvWidget: TvWidgetLike | any,
  selectedProduct: any,
  initialInterval: string,
  whenAboveMd: boolean
): void {
  if (!tvWidget) return;

  const defaultLayout = whenAboveMd ? '2h' : '2v';
  tvWidget?.setLayout?.(defaultLayout);

  const markSymbol = `MARK:${selectedProduct?.symbol ?? ''}`;
  const underlyingSymbol = selectedProduct?.spot_index?.symbol;

  const markChart = tvWidget?.chart?.(0);
  const spotChart = tvWidget?.chart?.(1);

  markChart?.setSymbol?.(markSymbol, { doNotActivateChart: true });
  spotChart?.setSymbol?.(underlyingSymbol, { doNotActivateChart: true });

  markChart?.setResolution?.(initialInterval, { doNotActivateChart: true });
  spotChart?.setResolution?.(initialInterval, { doNotActivateChart: true });

  const perPaneOverrides: Record<string, string | boolean> = {
    'mainSeriesProperties.statusViewStyle.showSymbol': true,
    'mainSeriesProperties.statusViewStyle.symbolTextSource': 'ticker',
    'paneProperties.legendProperties.showLegend': true,
    'paneProperties.legendProperties.showSeriesTitle': true,
  };

  markChart?.applyOverrides?.(perPaneOverrides);
  spotChart?.applyOverrides?.(perPaneOverrides);

  tvWidget?.unloadUnusedCharts?.();
}
